"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var FormCardCellModel = /** @class */ (function () {
    function FormCardCellModel() {
    }
    FormCardCellModel.cellWithController = function (controller) {
        var cell = new FormCardCellModel();
        cell.controller = controller;
        cell.id = controller.id;
        return cell;
    };
    FormCardCellModel.cellWithCard = function (card) {
        var cell = new FormCardCellModel();
        cell.card = card;
        cell.id = card.id;
        return cell;
    };
    FormCardCellModel.prototype.isController = function () {
        return !lodash_1.isNil(this.controller);
    };
    FormCardCellModel.prototype.isCard = function () {
        return !lodash_1.isNil(this.card);
    };
    Object.defineProperty(FormCardCellModel.prototype, "columnCount", {
        get: function () {
            if (this.isController()) {
                return this.controller.columnCount;
            }
            else {
                return this.card.columnCount;
            }
        },
        set: function (value) {
            if (this.isController()) {
                this.controller.columnCount = value;
            }
            else {
                this.card.columnCount = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    return FormCardCellModel;
}());
exports.FormCardCellModel = FormCardCellModel;
//# sourceMappingURL=form-card-cell.model.js.map